export const URLS = {
  HOME_URL: "/",
  ORDERS_URL: "/documenten/orders",
  INVOICES_URL: "/documenten/facturen",
  ACCOUNT_STATEMENTS_URL: "/documenten/rekeningoverzichten",
  DELIVERIES_URL: "/documenten/leveringen",
  RECEIPTS_RETURNS_URL: "/documenten/ontvangst_retouren",
  INSPECTION_REPORT_URL: "/documenten/kpb_ontvangstrapport",
  QUALITY_REPORT_URL: "/documenten/kpb_keurrapporten",
  MY_REPORTS_URL: "/overig/rapporten",
  SERVICE_AND_SUPPORT_URL: "/overig/service_support",
  USER_MANUALS_URL: "/user_manuals",
  MY_DELIVERIES_URL: "/invoeren/leveringen",
  DELIVERIES_PREFERENCES: "/invoeren/voorkeursinstellingen",
  MY_CULTIVATION_ADVICE_URL: "/admin/teeltadvies",
  CULTIVATION_ADVICE_URL: "/overig/teeltadvies",
  DELIVERY_NOTES_URL: "/invoeren/leveringen/leveringsnota",
  SETTINGS_URL: "/instellingen",
  CONTACT_URL: "/contact",
  ALL_NOTIFICATIONS_URL: "/all_notifications",
  MY_NOTIFICATIONS_URL: "/admin/notifications",
  AUTH_CALLBACK_URL: "/callback",
  AUTH_ERROR_URL: "/auth-error",
  OPEN_DOCUMENT: "/pdf",
  PRIVACY_STATEMENT: "/privacy_statement",
  CUSTOMER_COMPLAINTS: "/zuurnota",
  AREA_STATEMENT_CREATE_URL: "/invoeren/areaalopgave",
  AREA_STATEMENT_INFO_URL: "/bekijken/areaalopgave",
  AREA_STATEMENT_SPRING: "/invoeren/areaalopgaven/voorjaarsgewassen",
  AREA_STATEMENT_LELIE: "/invoeren/areaalopgaven/lelie",
  AREA_STATEMENT_ZANT: "/invoeren/areaalopgaven/zant",
  COMPANY_INFORMATION: "/bedrijfsgegevens",
  COMPANY_INFORMATION_EDIT: "/invoeren/bedrijfsgegevens",
};

interface ISideMenuItem {
  label: string;
  items: Array<{
    label: string;
    type?: string;
    url: string;
    roles: string[];
    indented?: boolean;
  }>;
}

export const SIDE_MENUS: ISideMenuItem[] = [
  {
    label: "ADMINISTRATION",
    items: [
      {
        label: "ORDERS",
        type: "Order",
        url: URLS.ORDERS_URL,
        roles: ["Orders"],
      },
      {
        label: "INVOICES",
        type: "Factuur",
        url: URLS.INVOICES_URL,
        roles: ["Financieel"],
      },
      {
        label: "ACCOUNT_STATEMENTS",
        type: "RekeningOverzicht",
        url: URLS.ACCOUNT_STATEMENTS_URL,
        roles: ["Financieel"],
      },
      {
        label: "ENTER_DELIVERIES",
        url: URLS.MY_DELIVERIES_URL,
        roles: ["Leveringen"],
      },
      {
        label: "PREFERENCES",
        url: URLS.DELIVERIES_PREFERENCES,
        roles: ["Leveringen"],
        indented: true,
      },
      {
        label: "DELIVERIES",
        type: "Levering",
        url: URLS.DELIVERIES_URL,
        roles: ["Orders", "Leveringen", "Financieel"],
      },
      {
        label: "RECEIPTS_AND_RETURNS",
        type: "ReceiptAndReturn",
        url: URLS.RECEIPTS_RETURNS_URL,
        roles: ["Orders", "Financieel", "Ontvangsten en retouren"],
      },
      {
        label: "CUSTOMER_COMPLAINTS",
        url: URLS.CUSTOMER_COMPLAINTS,
        roles: ["Algemeen"],
      },
      {
        label: "AREA_STATEMENT_CREATE",
        url: URLS.AREA_STATEMENT_CREATE_URL,
        roles: ["Algemeen"],
      },
      {
        label: "AREA_STATEMENT_INFO",
        url: URLS.AREA_STATEMENT_INFO_URL,
        roles: ["Algemeen"],
      },
    ],
  },
  {
    label: "REPORTS",
    items: [
      {
        label: "MY_REPORTS",
        url: URLS.MY_REPORTS_URL,
        roles: ["Financieel", "KPB_Documenten"],
      },
      {
        label: "INSPECTION_REPORT",
        type: "InspectionReport",
        url: URLS.QUALITY_REPORT_URL,
        roles: ["KPB_Documenten"],
      },
      {
        label: "RECEIPTS_REPORT",
        type: "Receipt",
        url: URLS.INSPECTION_REPORT_URL,
        roles: ["KPB_Documenten"],
      },
    ],
  },
  {
    label: "CULTIVATION_ADVICES",
    items: [
      {
        label: "CULTIVATION_ADVICES_MSG",
        type: "Teeltadvies",
        url: URLS.CULTIVATION_ADVICE_URL,
        roles: ["Algemeen"],
      },
    ],
  },
  {
    label: "OTHER",
    items: [
      {
        label: "NOTIFICATIONS",
        url: URLS.ALL_NOTIFICATIONS_URL,
        roles: ["Algemeen"],
      },
      {
        label: "COMPANY_DETAILS",
        url: URLS.COMPANY_INFORMATION,
        roles: ["Algemeen", "Administrator"],
      },
      {
        label: "SETTINGS",
        url: URLS.SETTINGS_URL,
        roles: ["Algemeen"],
      },
      {
        label: "SERVICE_AND_SUPPORT",
        url: URLS.SERVICE_AND_SUPPORT_URL,
        roles: ["Algemeen"],
      },
      {
        label: "USER_MANUALS",
        url: URLS.USER_MANUALS_URL,
        roles: ["Algemeen"],
      },
      {
        label: "CONTACT",
        url: URLS.CONTACT_URL,
        roles: ["Algemeen"],
      },
    ],
  },
  {
    label: "INTERNAL_MANAGE",
    items: [
      {
        label: "INTERNAL_NOTIFICATIONS",
        url: URLS.MY_NOTIFICATIONS_URL,
        roles: ["Administrator"],
      },
      {
        label: "INTERNAL_CULTIVATION_ADVICE",
        url: URLS.MY_CULTIVATION_ADVICE_URL,
        roles: ["Administrator", "NewsLetter Admin"],
      },
    ],
  },
];

export const HIDED_SIDE_MENUS = [
  {
    url: `${URLS.ORDERS_URL}/:id`,
    roles: ["Orders"],
  },
  {
    url: `${URLS.INVOICES_URL}/:id`,
    roles: ["Financieel"],
  },
  {
    url: `${URLS.DELIVERIES_URL}/:id`,
    roles: ["Orders", "Leveringen", "Financieel"],
  },
  {
    url: `${URLS.MY_CULTIVATION_ADVICE_URL}/new`,
    roles: ["Administrator", "NewsLetter Admin"],
  },
  {
    url: `${URLS.MY_NOTIFICATIONS_URL}/new`,
    roles: ["Administrator", "NewsLetter Admin"],
  },
];

export const ROUTES_WITH_ID = [
  {
    path: URLS.ORDERS_URL,
    name: "orderItem",
    label: "ORDER",
    key: "Number",
  },
  {
    path: URLS.INVOICES_URL,
    name: "invoiceItem",
    label: "INVOICE",
    key: "Number",
  },
  {
    path: URLS.DELIVERIES_URL,
    name: "deliveryItem",
    label: "DELIVERY",
    key: "DeliveryId",
  },
  {
    path: URLS.MY_CULTIVATION_ADVICE_URL,
    mainLabel: "CULTIVATION_ADVICES_EDIT",
  },
  {
    path: URLS.MY_NOTIFICATIONS_URL,
    mainLabel: "NOTIFICATIONS_EDIT",
  },
];

export default URLS;
